import type { PuzzleDef } from './types';
import type { PuzzleStatus } from './engine';

interface PuzzleListProps {
  puzzles: PuzzleDef[];
  getStatus: (id: string) => PuzzleStatus;
  onOpen: (id: string) => void;
}

const STATUS_ICONS: Record<string, string> = {
  solved: 'fa-circle-check',
  available: 'fa-lock-open',
  locked: 'fa-lock',
};

export function PuzzleList({ puzzles, getStatus, onOpen }: PuzzleListProps) {
  return (
    <ul className="escape-puzzle-list" aria-label="Room puzzles">
      {puzzles.map(puzzle => {
        const status = getStatus(puzzle.id);
        const statusKey = status.solved ? 'solved' : status.locked ? 'locked' : 'available';

        return (
          <li
            key={puzzle.id}
            className={`escape-puzzle-item escape-puzzle-item--${statusKey}`}
          >
            <button
              className="escape-puzzle-item__btn"
              type="button"
              disabled={status.locked}
              aria-label={`${puzzle.title} — ${statusKey}`}
              onClick={() => !status.locked && onOpen(puzzle.id)}
            >
              <i
                className={`fa-solid ${STATUS_ICONS[statusKey]} escape-puzzle-item__status`}
                aria-hidden="true"
              />
              <span className="escape-puzzle-item__title">{puzzle.title}</span>
              {!status.locked && !status.solved && (
                <i className="fa-solid fa-chevron-right escape-puzzle-item__arrow" aria-hidden="true" />
              )}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
